<ion-list>
  <ion-item
    *ngFor="let option of contextMenuOptions; let isLast = last"
    button
    [detail]="false"
    [lines]="isLast ? 'none' : 'full'"
    (click)="selectOption(option.value)"
  >
    <ion-icon
      slot="start"
      [name]="option.icon"
      size="small"
      aria-hidden="true"
    ></ion-icon>
    <ion-label>{{ option.label }}</ion-label>
  </ion-item>
</ion-list>
